import styled, { createGlobalStyle } from 'styled-components/macro';

import { COLORS, FONTS, TRANSITIONS } from '../../../styles/Theme';

// images
import arrowLeft from './images/arrowLeft.svg';
import arrowRight from './images/arrowRight.svg';

export const DatepickerWrapper = styled.div`
  width: 100%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 13px;
  line-height: 149.18%;
  text-align: center;
  color: ${COLORS.LIGHT_BLUE};

  & input {
    height: 24px;
    border: none;
    width: 100%;
    font-style: italic;
    font-weight: 300;
    font-size: 24px;
    line-height: 24px;
    background: transparent;
    color: transparent;
    background: beige;
    padding: 0;
    outline: none;
  }
`;

export const MonthTitle = styled.div`
  height: 24px;
  background: ${COLORS.WHITE};
  box-shadow: 0px 0.495305px 0.495305px rgb(0 14 51 / 5%);
  border-radius: 4px;
  width: 53px;
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  left: 38px;
`;

export const GlobalStyle = createGlobalStyle`
.react-datepicker {
  position: absolute;
  top: 50px;
  left: 16px;
  width: 186px;
  height: calc(100% - 50px - 16px);
  border-radius: 4px;
  padding: 16px;
  background: white;
  box-shadow: 0px 0.495305px 0.495305px rgb(0 14 51 / 5%);
  border: none;
}

.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker__month {
  margin: 0;
}

.react-datepicker__day {
  width: 25px;
  height: 22px;
  margin: 1px;
  font-family: ${FONTS.OPEN_SANS};
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 149.18%;
  text-align: center;
  color: ${COLORS.BLACK_LIGHT};
  border-radius: 2.97183px;
  outline: none;
  transition: ${TRANSITIONS.FAST};
}

.react-datepicker__day--disabled {
  color: ${COLORS.LIGHT_BLUE} !important;
  cursor: default !important;
  &:hover {
    color: ${COLORS.GREY_LIGHTER2} !important;
    cursor: default !important;
  }
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  color: ${COLORS.LIGHT_BLUE} !important;
  cursor: default !important;

  &:hover {
    color: ${COLORS.LIGHT_BLUE} !important;
  }
}

.react-datepicker__month-dropdown {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

.react-datepicker__month-container {
  width: calc(186px - 32px);
  left: 0;
  height: -webkit-fill-available;

  & > div:last-child {
    display: flex;
    justify-content: space-around;
    height: 100%;
    flex-direction: column;
  }
}

.react-datepicker__month 
.react-datepicker__month-text, 
.react-datepicker__month 
.react-datepicker__quarter-text {
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: -webkit-fill-available;
  color: ${COLORS.LIGHT_BLUE};
}

.react-datepicker__month-wrapper {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
}

.react-datepicker__month-text:hover, 
.react-datepicker__quarter-text:hover, 
.react-datepicker__year-text:hover {
  border-radius: 0 !important;
  background: none !important;
  color: ${COLORS.BLUE};
  font-weight: bold;
  outline: none !important;
}

.react-datepicker__day--selected,
.react-datepicker__day--keyboard-selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  color: ${COLORS.WHITE} !important;
}

.react-datepicker__day--keyboard-selected, 
.react-datepicker__month-text--keyboard-selected, 
.react-datepicker__quarter-text--keyboard-selected, 
.react-datepicker__year-text--keyboard-selected {
  background: white !important;
  color: ${COLORS.LIGHT_BLUE};
  outline: none;
}

.react-datepicker__day--outside-month {
  color: ${COLORS.WHITE};
  background: ${COLORS.WHITE};
  cursor: default !important;

  &:hover {
    color: ${COLORS.WHITE} !important;
    background: ${COLORS.WHITE} !important;
    cursor: default !important;
  }
}

.react-datepicker__header {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: ${COLORS.WHITE};
  box-shadow: 0px 0.495305px 0.495305px rgb(0 14 51 / 5%);
  border-radius: 4px;
  width: 50px;
  position: absolute;
  top: -34px;
  height: 24px;
  right: 34px;
  z-index: 1;
  font-size: 13px;
  line-height: 149.18%;
  text-align: center;
  color: ${COLORS.LIGHT_BLUE};
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker__current-month {
  font-family: ${FONTS.LATO};
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: ${COLORS.BROWN};
}

.react-datepicker__navigation {
  top: 26px;
}

.react-datepicker__navigation--next,
.react-datepicker__navigation--previous {
  width: 14px;
  border: none;
  outline: none;
  top: -34px;
  box-shadow: 0px 0px 10px rgba(55, 114, 182, 0.13);
  background-color: ${COLORS.WHITE};
  border-radius: 4px;
  height: 24px;
}

.react-datepicker__navigation--next {
  right: 0;
  background: url(${arrowRight});
  background-position: center center;
  background-repeat: no-repeat;
}

.react-datepicker__navigation--previous {
  left: 0;
  background: url(${arrowLeft});
  background-position: center center;
  background-repeat: no-repeat;
}

.react-datepicker__day-names {
  margin-top: 20px;
}

.react-datepicker__day-name {
  width: 25px;
  height: 22px;
  margin: 1px;
  font-family: ${FONTS.OPEN_SANS};
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 8px;
  line-height: 149.18%;
  text-align: center;
  color: ${COLORS.BLUE};
}

.react-datepicker__triangle {
  display: none;
  position: relative;
}

.react-datepicker__header react-datepicker-year-header {
  display: none;
}

.react-datepicker__month--selected,
.react-datepicker__month--in-selecting-range,
.react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  color: ${COLORS.BLUE} !important;
  background: ${COLORS.WHITE} !important;
  font-weight: bold;
}
`;
